/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Auth controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { ResetPasswordRequest, RequestOptions, ResetPasswordResponse, RefreshTokenRequest, RefreshTokenResponse, LoginRequest, LoginResponse, LicenceServerTokenRequest, LicenceServerTokenResponse, ForgotPasswordRequest } from "../models";

@Injectable({ providedIn: "root" })
export class AuthService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    resetPassword(resetPasswordRequest: ResetPasswordRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<ResetPasswordResponse>;
    resetPassword(resetPasswordRequest: ResetPasswordRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<ResetPasswordResponse>>;
    resetPassword(resetPasswordRequest: ResetPasswordRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<ResetPasswordResponse>>;
    /** Resets a user's password using a valid reset token */
    resetPassword(resetPasswordRequest: ResetPasswordRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Auth/ResetPassword`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, resetPasswordRequest, requestOptions);
    }

    refreshToken(refreshTokenRequest: RefreshTokenRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<RefreshTokenResponse>;
    refreshToken(refreshTokenRequest: RefreshTokenRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<RefreshTokenResponse>>;
    refreshToken(refreshTokenRequest: RefreshTokenRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<RefreshTokenResponse>>;
    /** Returns a new JWT and refresh token using a valid refresh token */
    refreshToken(refreshTokenRequest: RefreshTokenRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Auth/RefreshToken`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, refreshTokenRequest, requestOptions);
    }

    login(loginRequest: LoginRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<LoginResponse>;
    login(loginRequest: LoginRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<LoginResponse>>;
    login(loginRequest: LoginRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<LoginResponse>>;
    /** Authenticates a user and returns a JWT token */
    login(loginRequest: LoginRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Auth/Login`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, loginRequest, requestOptions);
    }

    issueLicenceServerToken(licenceServerTokenRequest: LicenceServerTokenRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<LicenceServerTokenResponse>;
    issueLicenceServerToken(licenceServerTokenRequest: LicenceServerTokenRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<LicenceServerTokenResponse>>;
    issueLicenceServerToken(licenceServerTokenRequest: LicenceServerTokenRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<LicenceServerTokenResponse>>;
    /** Exchanges a client id/secret for a short-lived JWT scoped to the licence server. */
    issueLicenceServerToken(licenceServerTokenRequest: LicenceServerTokenRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Auth/LicenceServer/Token`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, licenceServerTokenRequest, requestOptions);
    }

    forgotPassword(forgotPasswordRequest: ForgotPasswordRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    forgotPassword(forgotPasswordRequest: ForgotPasswordRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    forgotPassword(forgotPasswordRequest: ForgotPasswordRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    /** Generates a password reset token for the user */
    forgotPassword(forgotPasswordRequest: ForgotPasswordRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Auth/ForgotPassword`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, forgotPasswordRequest, requestOptions);
    }
}
